import { type BundleOf, DataHandler, type IDMap } from "data-handler"
import { LuxedoRPC } from "luxedo-rpc"

import { DeviceAdmin, type DeviceAdminRawData } from "../../entries/admin/DeviceAdmin"

class DHDeviceAdmin extends DataHandler<DeviceAdmin> {
	EntryClass = DeviceAdmin

	initialized: boolean = false

	protected initialize() {
		if (this.initialized) return

		console.warn("INITIALIZED DATAHANDLERDEVICEADMIN")
		LuxedoRPC.bindEndpoint("device_on_status_change", (id, eidos) => {
			if (id in this.entries) this.entries[id].onEidosUpdate(eidos)
		})

		this.initialized = true
	}

	protected async fetch(specificInstances?: number[] | undefined): Promise<BundleOf<DeviceAdmin>> {
		this.initialize()
		const data = await LuxedoRPC.api.bundlers.device_bundle_down_admin(specificInstances ?? [])
		return data
	}

	protected async pushData(entryData: { [id: number]: Partial<DeviceAdminRawData> }): Promise<void> {
		return await LuxedoRPC.api.bundlers.device_bundle_up_admin(entryData as IDMap<DeviceAdminRawData>)
	}
}

export const DataHandlerDeviceAdmin = new DHDeviceAdmin()
